import { twMerge } from "tailwind-merge";

export default function Card({ children, className }: { children: React.ReactNode; className?: string }) {
    return (
        <div className={twMerge("bg-white shadow-md flex rounded-lg p-6 flex-col gap-4", className ?? "")}>
            {children}
        </div>
    );
}